import { GoogleMapsEnterprise } from 'js/components/Maps/GoogleMapsEnterprise.js';
import { Maps } from 'js/components/Maps/index.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';

export class ClientMap extends GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.ClientMap";
  }
  constructor(args) {
    super(args);
    this.pinWidth = 32;
    this.pinHeight = 41.5;
  }
  svgPin(backgroundColor) {
    let url = this.element.baseURI;
    if (url && url.length > 10) {
      let url_ext = url.substr(url.length-10, url.length);
      if (url_ext === "geek-squad" && backgroundColor == null) {
        backgroundColor = '#e37222';
      }
    }
    if (backgroundColor == null) { backgroundColor = '#085EB9'; }
    let rendered = `
      <svg xmlns="http://www.w3.org/2000/svg"
           width="${this.pinWidth}"
           height="${this.pinHeight}"
           viewBox="0 0 ${this.pinWidth} ${this.pinHeight}">
          <defs>
            <style type=\"text/css\">
              text {
                font-family: sans-serif;
                font-weight: 400;
                font-size: 42px;
              }
            </style>
          </defs>
          <g>
            <path fill="${backgroundColor}" fill-rule="evenodd" d="M0 16c0 11.44 16 26 16 26s16-14.56 16-26c0-8.58-7.086-16-16-16S0 7.42 0 16z"/>
            <text fill='#fff'>
              <tspan x='${this.pinWidth/2}'
                    y='32'
                    text-anchor='middle'>
                    •
              </tspan>
            </text>
          </g>
      </svg>
    `;
    return rendered;
  }
}

ClientMap.initClass();
